"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.CarouselImagesDefaultProps = exports.CarouselImages = void 0;
var _carouselImages = _interopRequireDefault(require("./components/carousel-images"));
exports.CarouselImages = _carouselImages["default"];
var _carouselImages2 = _interopRequireDefault(require("./components/carousel-images.props/carousel-images.defaultProps"));
exports.CarouselImagesDefaultProps = _carouselImages2["default"];